<template>
  <div class="drop_ships">
    <div style="margin:10px">
      <v-row>
        <v-col cols="12">
          <v-card height="350px" elevation="12">
            <v-card-title>
              <v-row>
                <v-col col="6">Open Drop Ship POs</v-col>
                <v-col col="6"><v-text-field label="Search..." variant="solo" density="compact" hide-details="true" @input="debouncedOpenDropShipSearch($event)" style="width:250px;float:right"></v-text-field></v-col>
              </v-row>              
            </v-card-title>
            <v-card-text>
              <Vue3EasyDataTable
                :headers = "open_drop_ships_headers"
                :items="open_drop_ships"
                :rows-per-page="2000"
                :hide-rows-per-page="true"
                :hide-footer="false"
                :table-height="225"
                :search-value="searchOpenDropShips"
              >
                <template #item-po_number="item">
                  <span class="dashboard-link" v-if="item.po_number" @click="openPurchaseOrderDetailPopup(item.po_number)">{{item.po_number}}</span>
                </template>
                <template #item-po_date_sortable="item">
                  {{item.po_date_formatted}}
                </template>
                <template #item-vendor_name="item">
                  <router-link :to="{ name: 'vendor', params: {vendorpageid: item.vendor_page ? item.vendor_page : 'null'}}" target="_blank" style="color:#ff7214;font-weight: bold">{{item.vendor_name}}</router-link>
                </template>
                <template #item-internal_notes="item">
                  <div v-for="n in item.internal_notes" style="border-bottom:1px dashed gray;margin-top:5px;margin-bottom:5px;line-height:100%">
                    <div style="font-style:italic">{{n.note}}</div>
                    <div style="font-size:8px;line-height:100%;color:gray;">submitted {{formatDate(n.submitted_date)}} by {{n.submitted_by}}</div>
                  </div>
                </template>
              </Vue3EasyDataTable>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn style="background:#ff7214;color:white;height:15px;width:50px;font-size:8px;" @click="exportOpenDropships()" :disabled="open_drop_ships.length === 0">EXPORT</v-btn>
              </v-card-actions>              
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card height="350px" elevation="12">
            <v-card-title>
              <v-row>
                <v-col col="6">Recently Completed Drop Ship POs (completed in the last 7 days)</v-col>
                <v-col col="6"><v-text-field label="Search..." variant="solo" density="compact" hide-details="true" @input="debouncedCompletedDropShipSearch($event)" style="width:250px;float:right"></v-text-field></v-col>
              </v-row>              
            </v-card-title>
            <v-card-text>
              <Vue3EasyDataTable
                :headers = "recently_completed_drop_ships_headers"
                :items="recently_completed_drop_ships"
                :rows-per-page="2000"
                :hide-rows-per-page="true"
                :hide-footer="false"
                :table-height="245"
                :search-value="searchCompletedDropShips"
              >
                <template #item-po_date_sortable="item">
                  {{item.po_date_formatted}}
                </template>
                <template #item-po_completed_date_sortable="item">
                  {{item.po_completed_date_formatted}}
                </template>                
                <template #item-vendor_name="item">
                  <router-link :to="{ name: 'vendor', params: {vendorpageid: item.vendor_page ? item.vendor_page : 'null'}}" target="_blank" style="color:#ff7214;font-weight: bold">{{item.vendor_name}}</router-link>
                </template>
                <template #item-internal_notes="item">
                  <div v-for="n in item.internal_notes" style="border-bottom:1px dashed gray;margin-top:5px;margin-bottom:5px;line-height:100%">
                    <div style="font-style:italic">{{n.note}}</div>
                    <div style="font-size:8px;line-height:100%;color:gray;">submitted {{formatDate(n.submitted_date)}} by {{n.submitted_by}}</div>
                  </div>
                </template>
              </Vue3EasyDataTable>
              <v-card-actions>
                <div style="color:gray;font-size:10px">Record Count: {{recently_completed_drop_ships.length}}</div>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
  <PurchaseOrderDetailPopUp v-if="po_detail" :po='po_for_component' @close="closePurchaseOrderDetailPopup()" />
</template>

<script>
import { mapGetters } from 'vuex'
import Moment from 'moment-business-days'
import Vue3EasyDataTable from 'vue3-easy-data-table';
import XLSX from 'xlsx'
import PurchaseOrderDetailPopUp from '@/components/PurchaseOrderDetailPopUp.vue'
import { debounce } from 'lodash';

export default {
  name: 'DropShips',
  components: {Vue3EasyDataTable, PurchaseOrderDetailPopUp},
  data(){
    return {
      open_drop_ships_headers: [
        { text: "PO Number", value: "po_number", sortable: true},
        { text: "PO Date", value: "po_date_sortable", sortable: true},
        { text: "Vendor", value: "vendor_name", sortable: true },
        { text: "Customer", value: "customer_name", sortable: true },
        { text: "PO Internal Notes", value: "internal_notes", sortable: false}
      ],
      recently_completed_drop_ships_headers: [
        { text: "PO Number", value: "po_number", sortable: true},
        { text: "PO Date", value: "po_date_sortable", sortable: true},
        { text: "PO Completed Date", value: "po_completed_date_sortable", sortable: true},
        { text: "Vendor", value: "vendor_name", sortable: true },
        { text: "Customer", value: "customer_name", sortable: true },
        { text: "PO Internal Notes", value: "internal_notes", sortable: false}        
      ],
      searchOpenDropShips: '',
      searchCompletedDropShips: '',       
      po_detail: false,
      po_for_component: null
    }
  },
  beforeMount(){
    if (this.user === 'vendor' || !this.user) {
      this.$router.push('/')
    }
  },  
  computed: {
    ...mapGetters(['db','user']),
    open_drop_ships(){
      var purchase_orders = JSON.parse(JSON.stringify( this.db.purchase_orders))
      var module_data = []
      for(var id in purchase_orders){
        var po_info = purchase_orders[id]
        var open = po_info.action_po_complete === 'N'
        var first_item = po_info.items[Object.keys(po_info.items)[0]]
        var dropship = first_item.drop_ship
        po_info.customer_name = first_item.ship_to_name
        po_info.po_date_sortable = Moment(po_info.po_date).startOf('day')
        po_info.po_date_formatted = this.formatDate(po_info.po_date_sortable)
        po_info.vendor_page = this.db.vendors['vendor_'+po_info.vendor_number] ? this.db.vendors['vendor_'+po_info.vendor_number].page : ''

        po_info.internal_notes_flat = po_info.internal_notes
          ? Object.values(po_info.internal_notes)
              .map(n => `${n.note ?? ''} ${n.submitted_by ?? ''}`)
              .join(' ')
          : '';

        if(open && dropship){
          module_data.push(po_info)
        }
      }
      return module_data
    },
    recently_completed_drop_ships(){
      var purchase_orders = JSON.parse(JSON.stringify( this.db.recently_completed_purchase_orders))
      var module_data = []
      for(var id in purchase_orders){
        var po_info = purchase_orders[id]
        var open = po_info.action_po_complete === 'Y'
        var first_item = po_info.items[Object.keys(po_info.items)[0]]
        var dropship = first_item.drop_ship
        po_info.customer_name = first_item.ship_to_name
        po_info.po_date_sortable = Moment(po_info.po_date).startOf('day')
        po_info.po_date_formatted = this.formatDate(po_info.po_date_sortable)
        po_info.po_completed_date_sortable = Moment(po_info.po_complete_date).startOf('day')
        po_info.po_completed_date_formatted = this.formatDate(po_info.po_completed_date_sortable)
        po_info.vendor_page = this.db.vendors['vendor_'+po_info.vendor_number] ? this.db.vendors['vendor_'+po_info.vendor_number].page : ''

        po_info.internal_notes_flat = po_info.internal_notes
          ? Object.values(po_info.internal_notes)
              .map(n => `${n.note ?? ''} ${n.submitted_by ?? ''}`)
              .join(' ')
          : '';

        if(open && dropship){
          module_data.push(po_info)
        }
      }
      return module_data      
    }
  },
  methods: {
    debouncedOpenDropShipSearch: debounce(function(event) {
      this.searchOpenDropShips = event.target._value.replace(/\*/g, "");
    }, 500),
    debouncedCompletedDropShipSearch: debounce(function(event) {
      this.searchCompletedDropShips = event.target._value.replace(/\*/g, "");
    }, 500),
    exportOpenDropships(){
        var items = this.open_drop_ships
        var export_arr = []
        for(var i = 0; i < items.length; i++){
          var item = items[i]
          var row_item = {
            'PO Number' : item.po_number,
            'PO Date': item.po_date_formatted,
            'Vendor': item.vendor_name,
            'Customer': item.customer_name,
            'PO Internal Notes': ''
          }
          for(var n in item.internal_notes){
            row_item['Internal Notes'] += item.internal_notes[n].note + ' (' + item.internal_notes[n].submitted_by + ' on ' + this.formatDate(item.internal_notes[n].submitted_date) + '), '
          }
          export_arr.push(row_item)
        }
        var wscols = [
            {wch:30},
            {wch:30},
            {wch:30},
            {wch:30},
            {wch:100},
        ];
        var worksheet = XLSX.utils.json_to_sheet(export_arr)
        worksheet['!cols'] = wscols;
        var workbook = XLSX.utils.book_new()
        var export_date = Date.now()
        XLSX.utils.book_append_sheet(workbook, worksheet)
        XLSX.writeFile(workbook, 'Open Drop Ship POs ' + export_date + '.xlsx')
    },
    openPurchaseOrderDetailPopup(po){
      this.po_for_component = po
      this.po_detail = true
    },
    closePurchaseOrderDetailPopup(){
      this.po_for_component = null
      this.po_detail = false
    },
    formatDate(date){
      return Moment(date).format('MM/DD/YY')
    }
  }
}
</script>

<style scoped>

  .v-card .v-card-title{
    color: gray;
    font-size: 14px;
  }

  .v-card .v-card-text {
    line-height: 100%;
  }

  .table-container{
    position: relative;
    top: 5px;
    margin:0px 20px;
  }

  .flagged{
    width: 20px;
    height: 20px;
    border:1px solid #ff7214;
    background: #ff7214;
    cursor: pointer;
  }

  .unflagged{
    width: 20px;
    height: 20px;
    border:1px solid #ff7214;
    cursor: pointer;
  }

  .needs_attention{
    background: red;
    color: white;
    width: 15px;
    height: 15px;
    text-align: center;
    font-size: 12px;
    line-height: 140%;
    font-weight: bold;
    border-radius: 100%;
  }

  a{
    text-decoration: none;
  }

  .v-card-actions{
    min-height: 0px;
    padding: 4px 0px;
  }

  .dashboard-link{
    color:#ff7214;
    cursor:pointer;
    font-weight: bold;
    font-size: 11px;
    /*text-decoration: underline;*/

  }
</style>
